import AboveMiddleBelow from "../../components/UKG/Mathematics/AboveMiddleBelow";
import BeforeAfter from "../../components/UKG/Mathematics/BeforeAfter";
import BigSmall from "../../components/UKG/Mathematics/BigSmall";
import FrontBack from "../../components/UKG/Mathematics/FrontBack";
import FullEmpty from "../../components/UKG/Mathematics/FullEmpty";
import HeavyLight from "../../components/UKG/Mathematics/HeavyLight";
import InOut from "../../components/UKG/Mathematics/InOut";
import LeftRight from "../../components/UKG/Mathematics/LeftRight";
import LongShort from "../../components/UKG/Mathematics/LongShort";
import MoreLess from "../../components/UKG/Mathematics/MoreLess";
import NearFar from "../../components/UKG/Mathematics/NearFar";
import OddOneOut from "../../components/UKG/Mathematics/OddOneOut";
import ThinThick from "../../components/UKG/Mathematics/ThinThick";
import TopBottom from "../../components/UKG/Mathematics/TopBottom";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - UKG - Mathematics";

const topics: MenuItem[] = [
    { url: "/ukg/mathematics/pre-math-concepts/big-small", title: "Big - Small", component: BigSmall},
    { url: "/ukg/mathematics/pre-math-concepts/long-short", title: "Long - Short", component: LongShort},
    { url: "/ukg/mathematics/pre-math-concepts/heavy-light", title: "Heavy - Light", component: HeavyLight},
    { url: "/ukg/mathematics/pre-math-concepts/front-back", title: "Front - Back", component: FrontBack},
    { url: "/ukg/mathematics/pre-math-concepts/in-out", title: "In - Out", component: InOut},
    { url: "/ukg/mathematics/pre-math-concepts/thin-thick", title: "Thin - Thick", component: ThinThick},
    { url: "/ukg/mathematics/pre-math-concepts/top-bottom", title: "Top - Bottom", component: TopBottom},
    { url: "/ukg/mathematics/pre-math-concepts/full-empty", title: "Full - Empty", component: FullEmpty},
    { url: "/ukg/mathematics/pre-math-concepts/more-less", title: "More - Less", component: MoreLess},
    { url: "/ukg/mathematics/pre-math-concepts/near-far", title: "Near - Far", component: NearFar},
    { url: "/ukg/mathematics/pre-math-concepts/above-middle-below", title: "Above - Middle - Below", component: AboveMiddleBelow},
    { url: "/ukg/mathematics/pre-math-concepts/left-right", title: "Left - Right", component: LeftRight},
    { url: "/ukg/mathematics/pre-math-concepts/before-after-between", title: "Before - Between - After", component: BeforeAfter},
    { url: "/ukg/mathematics/pre-math-concepts/odd-one-out", title: "Odd One Out", component: OddOneOut},
];


export default topics;